import useStyles from "isomorphic-style-loader/useStyles";
import React, { useEffect, useRef } from "react";
import Mask from "../../../../../../components/alert/mask";
import { Iconfont } from "../../../../../../components/icon/iconfont";
import BottomToTop from "../../../../../../components/transitions/bottom-to-top";
import itemScroll from "../../../../../../hocs/item-scroll";
import classes from './style.module.scss';

const SubmitImageBox = props => {
    useStyles(classes)

    const {
        intl,
        questionObject,
        deleteImg,
        questionImgUpload,
        maskUpload
    } = props

    return (
        <div className={classes.SubmitImageBox} id="imgUpload">
            {/* 标题 */}
            <div className={classes.SelectReasonTitle}>
                {intl.formatMessage({ id: 'upload_image' })}
            </div>

            {/* 上传提示 */}
            <div className={classes.UploadTips}>{intl.formatMessage({ id: 'image_formate' })}</div>

            {/* 上传盒子 */}
            <div className={classes.UploadBox}>
                {
                    questionObject?.uploadImgList?.map((item, index) => (
                        <div className={classes.UploadItem} key={index}>
                            <Iconfont className={classes.DeleteImg} onClick={() => deleteImg(index)}>&times;</Iconfont>
                            <img src={item} alt="" />
                        </div>
                    ))
                }
                {
                    questionObject?.uploadImgList?.length < 3 &&
                    // <label htmlFor="imageFiles">
                    <div className={classes.UploadItem}>
                        <Iconfont className={classes.UploadItemIcon}>&#xe6d3;</Iconfont>
                        <input className={classes.UploadItemInput}
                            type="file"
                            id="imageFiles"
                            ref={e => maskUpload.current = e}
                            multiple="multiple"
                            onChange={(e) => questionImgUpload(e)}
                            accept="image/jpg,image/jpeg,image/png,image/gif"></input>
                    </div>
                }

            </div>
        </div>
    )
}

const SubmitDescriptionBox = props => {
    useStyles(classes)
    const {
        intl,
        questionObject,
        setQuestionObject,
        descriptionRequired,
        descriptionBorder
    } = props

    return (
        <div className={classes.SubmitDescriptionBox} id="description" ref={descriptionBorder}>
            {/* 标题 */}
            <div className={classes.SelectReasonTitle}>
                {
                    descriptionRequired &&
                    <span>*</span>
                }
                {intl.formatMessage({ id: 'description' })}
            </div>

            {/* 输入框 */}
            <textarea className={classes.DescriptionTextArea}
                placeholder={intl.formatMessage({ id: 'description_ph' })}
                value={questionObject.descriptionInput}
                onChange={(e) => {
                    setQuestionObject({
                        ...questionObject,
                        descriptionInput: e.target.value
                    })
                }}
            ></textarea>
            <div className={classes.TextAreaInputLength}>
                {(questionObject?.descriptionInput?.length || '0') + '/1000'}
            </div>
        </div>
    )
}

const ReasonSelectBox = props => {
    useStyles(classes)
    const {
        intl,
        questionsReason,
        questionObject,
        setQuestionObject,
        questionReasonChange,
        bodyScrollTop,
        bottomPx,
        submitSelectBorder,
        reasonInputOthersBorder,
        bodyScroll
    } = props
    return (
        <div className={classes.SubmitSelectReason} id="submitSelect" ref={submitSelectBorder}>
            {/* 选择标题 */}
            <div className={classes.SelectReasonTitle}>
                <span>*</span> {intl.formatMessage({ id: 'select_reason' })}
            </div>

            {/* 选择下拉框 */}
            <div className={classes.SelectReasonBox} id="selectReason">
                <div className={classes.SelectReasonInput} onClick={() => setQuestionObject({ ...questionObject, showSelectItem: !questionObject.showSelectItem })}>
                    <span className={classes.ReasonTitle}>{questionsReason.find(q => q.isSelected)?.label || intl.formatMessage({ id: 'select_reason' })}</span>
                    <Iconfont className={`${classes.SelectReasonIcon} ${questionObject.showSelectItem ? classes.ReasonSelected : ''}`}>&#xe692;</Iconfont>
                </div>

                {/* 选项框 */}
                <div className={classes.SelectReasonItemBox}>
                    {/* 选项 */}
                    {
                        questionObject?.showSelectItem &&
                        questionsReason?.map((item, index) => (
                            <div className={classes.SelectReasonItem}
                                    key={index}
                                    style={{paddingBottom: `${item.value === questionsReason[questionsReason.length - 1]?.value && item.isSelected ? bottomPx(17):'0'}`}}
                                    onClick={() => questionReasonChange(item)}>
                                <div>
                                    <div className={classes.ReasonItemIcon} style={{borderColor: item.isSelected ? '#222': '#999'}}>
                                        {
                                            item.isSelected &&
                                            <div className={classes.ReasonItemIconSelected}></div>
                                        }
                                    </div>
                                    <div className={classes.ReasonItem} style={{color: itemScroll.isSelected ? '#222': '#666'}}>{item.label}</div>
                                </div>

                                {
                                    item.value === questionsReason[questionsReason.length - 1].value && item.isSelected &&
                                    <textarea className={classes.ReasonTextArea}
                                        value={questionObject?.questionTypeInput}
                                        ref={reasonInputOthersBorder}
                                        id={"reasonInput" + item.label}
                                        onFocus={() => { document.body.scrollTop = document.body.scrollHeight }}
                                        onBlur={() => { document.body.scrollTop = bodyScroll }}
                                        onChange={(e) => {
                                            setQuestionObject({
                                                ...questionObject,
                                                questionTypeInput: e.target.value
                                            })
                                        }}>
                                    </textarea>
                                }
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

const MaskContent = props => {
    useStyles(classes)
    const {
        intl,
        clearTicketData,
        questionsReason,
        questionSubmit,
        show
    } = props

    const bodyScrollRef = useRef(document.body.scrollTop)

    return (
        <div className={classes.SubmitQuestionContent}>
            {/* 关闭按钮 */}
            <span className={classes.SubmitQuestionCloseBox} onClick={() => clearTicketData()}>
                <Iconfont className={classes.SubmitQuestionClose}>&#xe69a;</Iconfont>
            </span>

            <div className={classes.ContentBox}>
                {/* 提示语 */}
                <div className={classes.SubmitTips} id="top">
                    <span>{intl.formatMessage({ id: 'submit_tips' })}</span>
                </div>

                {/* 原因选择 */}
                {
                    questionsReason?.length > 0 &&
                    <ReasonSelectBox {...props} bodyScroll={bodyScrollRef.current}/>
                }

                {/* 文字描述 */}
                <SubmitDescriptionBox {...props}/>

                {/* 图片上传 */}
                <SubmitImageBox {...props}/>
            </div>

            {/* 提交按钮 */}
            {
                show &&
                <div className={classes.QuestionSubmitBtnBox}>
                    <div className={classes.QuestionSubmitBtn} onClick={() => questionSubmit()}>
                        {intl.formatMessage({ id: 'submit' })}
                    </div>
                </div>
            }

        </div>
    )
}

export const SubmitQuestionMask = props => {
    useStyles(classes)

    return (
            <BottomToTop in={props?.show} className={classes.BottomToTopBox}>
                <div className={classes.SubmitQuestionMask}>
                    {
                        props?.show &&
                        <Mask onClick={() => props?.clearTicketData()}/>
                    }
                    <MaskContent {...props}/>
                </div>
            </BottomToTop>
    )
}